import { AdminMembersReportPathwayProgressFragment$key } from "@/admin/insights/member-reports/tabs/products/__generated__/AdminMembersReportPathwayProgressFragment.graphql"
import { useLabel } from "@/core/context/LabelsContext"
import { DiscoChip, DiscoIcon, DiscoText } from "@disco-ui"
import { useFragment } from "react-relay"
import { graphql } from "relay-runtime"

type Props = {
  memberKey: AdminMembersReportPathwayProgressFragment$key
}

export default function AdminMembersReportPathwayProgress({ memberKey }: Props) {
  const productLabel = useLabel("admin_experience")

  const pm = useFragment<AdminMembersReportPathwayProgressFragment$key>(
    graphql`
      fragment AdminMembersReportPathwayProgressFragment on ProductMembership {
        completedAt
        pathwayMemberProgressReport {
          totalGroups
          currentGroup
          currentGroupTotalProducts
          currentGroupCompletedProducts
        }
      }
    `,
    memberKey
  )
  const {
    totalGroups = 0,
    currentGroup = 0,
    currentGroupTotalProducts = 0,
    currentGroupCompletedProducts = 0,
  } = pm.pathwayMemberProgressReport || {}

  return pm.completedAt ? (
    <DiscoChip
      label={"Completed"}
      leftIcon={<DiscoIcon icon={"check"} height={16} width={16} />}
      color={"green"}
    />
  ) : (
    <>
      <DiscoText
        variant={"body-sm"}
      >{`Pathway Group ${currentGroup}/${totalGroups}`}</DiscoText>
      <DiscoText
        variant={"body-sm"}
      >{`${currentGroupCompletedProducts}/${currentGroupTotalProducts} ${productLabel.plural} Completed`}</DiscoText>
    </>
  )
}
